import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat' // load on demand
dayjs.extend(advancedFormat) // use plugin
let moment = dayjs;

import template from "string-template";


export async function getData(chart, parameters) {

  let realtime = resolve("cacheable.value", parameters, false);
  let chartDataSource = parameters.chartDataSource;
  let query = {};
  let fullQuery = chartDataSource.item.fullQuery;
  let sqlQuery = resolve("sqlQuery.value", parameters);
  if(sqlQuery) {
    fullQuery = sqlQuery;
  }
  query.realtime = !realtime;
  query.id = chartDataSource.item.id;
  let _filters = resolve("tree.filters", chart);
  let filters = _filters ? Object.values(_filters) : [];

  let sqlFilter = createFilter(chart, parameters);

  let sql = "SELECT * FROM (" + fullQuery + ") AS _subQuery ";
  sql += "WHERE 1 = 1 ";
  if(sqlFilter) {
    sql = sql + " AND " + sqlFilter;
  }

  query.sql = sql;
  let response = await chartDataSource.item.request(query);
  return response.data;
}

export function pickItem(data) {
  if (typeof data.items == "undefined") {
    return null;
  }
  return data.items.find(x => x[data.itemValue] === data.value);
}

function shadeHexColor(color, percent) {
    var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
    return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
}

export function createCSSGradient(color, percentage) {
  return "linear-gradient(90deg, " + color + ", " + shadeHexColor(color, percentage) + ")";
}

export function createFilter(chart, parameters) {
  let parameterisedFilterObject = resolve("tree.parameterisedFilterObject", chart);
  let parameterisedFilter = resolve("parameterisedFilter.value", parameters, "");
  let customFilter = resolve("customFilter.value", parameters, "");


//  console.log('parameterisedFilter', parameterisedFilter);
//  console.log('parameterisedFilterObject', parameterisedFilterObject);

  let sqlFilter = "";

  if(Object.keys(parameterisedFilterObject).length != 0 && parameterisedFilter.trim()) {
    sqlFilter =  template(parameterisedFilter, parameterisedFilterObject);
  }

  if(customFilter.trim()) {
    sqlFilter = sqlFilter ? sqlFilter + " AND " + customFilter : customFilter;
  }

  return sqlFilter;
}

export function applyChartParameters(chart, parameters) {
  chart.overlayContent = resolve("overlayContent.value", parameters, "");
  chart.overlayContentStyle = resolve("overlayContentStyle.value", parameters, "position: fixed; font-size: 14px;  z-index: 20000; top: 25%; right: 12%; width: 320px; min-height: 150px; height: auto; background-color: rgba(0, 0, 0, 0.5); padding: 10px; color: #fff;");
  // return "linear-gradient(90deg, " + color + ", " + shadeHexColor(color, percentage) + ")";
}

export function extractColors(colors) {
  let $return = {};


  if(colors && colors != "''") {
    let list = colors.trim().split(",");
    for(let i = 0; i < list.length; i++) {
      let c = list[i].trim().split(":");
      if(c.length > 1) {
        $return[c[0]] = c[1].trim();
      } else {
        $return[i] = c[0].trim();
      }
    }
  } else {
    $return = {
      0: '#003f5c',
      1: '#58508d',
      2: '#bc5090',
      3: '#ff6361',
      4: '#ffa600',
      5: '#003f5c',
      6: '#58508d',
      7: '#bc5090',
      8: '#ff6361',
      9: '#ffa600',
      10: '#003f5c',
      11: '#58508d',
      12: '#bc5090',
      13: '#ff6361',
      14: '#ffa600',
      15: '#003f5c',
      16: '#58508d',
      17: '#bc5090',
      18: '#ff6361',
      19: '#ffa600'
    }
  }
  return $return;
}


export function getSeriesColors(colors, series) {
  let $return = [];
  if(typeof series == "undefined") {
     return Object.values(colors);
  }
  let size = Object.values(colors).length;
  for (let i = 0; i < series.length; i++) {
    let row = series[i];
    let color = null;
    if(!color && typeof row.name != "undefined" && row.name) {
      color = getColor(row.name, colors);
    }
    if (!color && typeof row.color != "undefined" && row.color) {
      color = row.color;
    }
    if(!color && isString(row)) {
      color = getColor(row, colors);
    }

    if(!color) {
      if(i + 1 >=  size) {
        // console.log("modulus", (i+1)%size);
        color = getColor((i+1)%size, colors);
      } else {
        color = getColor(i+1, colors);
      }

    }

    // console.log("color series " + i, row);
    // console.log("color series" + i, color);

    if(color) {
      if (typeof colors[i] != "undefined") {
        $return[i] = color;
      } else {
        $return.push(color);
      }
    }
  }
  return $return;
}

function getColor(key, colors) {
  // console.log(key, colors);
  if(typeof colors == "undefined") {
    colors = {
      "UNALLOCATED": "#D50000",
      "ALLOCATED": "#1E88E5",
    }
  }

  if (typeof colors[key] != "undefined") {
    return colors[key];
  }
  return null;
}

export function seriesHead(row) {
  let result = {
    name: row.name,
    sum: 0,
    average: 0,
    minimum: 0,
    maximum: 0,
    data: []
  }
  if (typeof row.type != 'undefined') {
    result.type = row.type;
  }
  if (typeof row.color != 'undefined') {
    result.color = row.color;
  }
  let color = getColor(result.name);

  if (color) {
    result.color = color;
  }

  if (typeof row.backgroundColor != 'undefined') {
    result.backgroundColor = row.backgroundColor;
  }
  if (typeof row.class != 'undefined') {
    result.class = row.class;
  }
  // console.log("result", result);
  return result;
}

const arrMin = arr => Math.min(...arr);
const arrMax = arr => Math.max(...arr);
const arrSum = arr => arr.reduce((a, b) => a + b, 0);
const arrAvg = arr => arr.reduce((a, b) => a + b, 0) / arr.length;

const labels = {
  'sunday': {
    label: 'Sundays',
    sortKey: 0
  },
  'monday': {
    label: 'Mondays',
    sortKey: 1
  },
  'tuesday': {
    label: 'Tuesdays',
    sortKey: 2
  },
  'wednesday': {
    label: 'Wednesdays',
    sortKey: 3
  },
  'thursday': {
    label: 'Thursdays',
    sortKey: 4
  },
  'friday': {
    label: 'Fridays',
    sortKey: 5
  },
  'saturday': {
    label: 'Saturdays',
    sortKey: 6
  },
  'sun': {
    label: 'Sundays',
    sortKey: 0
  },
  'mon': {
    label: 'Mondays',
    sortKey: 1
  },
  'tue': {
    label: 'Tuesdays',
    sortKey: 2
  },
  'wed': {
    label: 'Wednesdays',
    sortKey: 3
  },
  'thur': {
    label: 'Thursdays',
    sortKey: 4
  },
  'fri': {
    label: 'Fridays',
    sortKey: 5
  },
  'sat': {
    label: 'Saturdays',
    sortKey: 6
  },
  'weekday': {
    label: 'Weekdays',
    sortKey: 0
  },
  'weekend': {
    label: 'Weekends',
    sortKey: 1
  },
  'jan': {
    label: 'January',
    sortKey: 0
  },
  'feb': {
    label: 'February',
    sortKey: 1
  },
  'mar': {
    label: 'March',
    sortKey: 2
  },
  'apr': {
    label: 'April',
    sortKey: 3
  },
  'may': {
    label: 'May',
    sortKey: 4
  },
  'jun': {
    label: 'June',
    sortKey: 5
  },
  'jul': {
    label: 'July',
    sortKey: 6
  },
  'aug': {
    label: 'August',
    sortKey: 7
  },
  'sept': {
    label: 'September',
    sortKey: 8
  },
  'oct': {
    label: 'October',
    sortKey: 9
  },
  'nov': {
    label: 'November',
    sortKey: 10
  },
  'dec': {
    label: 'December',
    sortKey: 11
  },
  'january': {
    label: 'January',
    sortKey: 0
  },
  'february': {
    label: 'February',
    sortKey: 1
  },
  'march': {
    label: 'March',
    sortKey: 2
  },
  'april': {
    label: 'April',
    sortKey: 3
  },
  'june': {
    label: 'June',
    sortKey: 5
  },
  'july': {
    label: 'July',
    sortKey: 6
  },
  'august': {
    label: 'August',
    sortKey: 7
  },
  'september': {
    label: 'September',
    sortKey: 8
  },
  'october': {
    label: 'October',
    sortKey: 9
  },
  'november': {
    label: 'November',
    sortKey: 10
  },
  'december': {
    label: 'December',
    sortKey: 11
  }
};

export function appendAggregateValues(data) {
  for (let i = 0; i < data.length; i++) {
    const arr = data[i].data.filter(function(e) {
      return e.y != null;
    }).map(function(d) {
      return d.y ? d.y : 0;
    });
    data[i].dataArray = arr;
    data[i].sum = arrSum(arr);
    data[i].average = arrAvg(arr);
    data[i].minimum = arrMin(arr);
    data[i].maximum = arrMax(arr);
  }
  return data;
}

export function missingValuesModel(data, annotations, dateTime = false) {
  let annotation = null;
  data.forEach(series => {
    series.data.forEach((item, i) => {
      if (item.y == null && annotation == null) {
        annotation = {
          x: dateTime == true ? new Date(item.x).getTime() : item.x,
          ax: item.x,
          bx: item.x,
          x2: dateTime == true ? new Date(item.x).getTime() : item.x,
          fillColor: '#B3F7CA',
          opacity: 0.4,
          label: {
            borderColor: '#B3F7CA',
            style: {
              fontSize: '10px',
              color: '#fff',
              background: '#00E396',
            },
            offsetY: -10,
            text: 'Missing Values'
          }
        };
        // annotations.points.push(annotation);
      } else if (item.y == null && annotation != null) {
        annotation.ax = item.x;
        annotation.x = dateTime == true ? new Date(item.x).getTime() : item.x;
      } else if (item.y != null && annotation != null) {
        annotations.xaxis.push({
          ...annotation
        });
        annotation = null;
      }
    })
  });
  return annotations;
}

export function resolve(path, obj, def = undefined) {
  let r = __resolve(path, obj, def);
  if(typeof r == 'undefined') {
    return def;
  }
  return r;
}
function __resolve(path, obj, def = undefined) {
  let paths = path.split('.');
  //  if(paths.length == 5) {

  //  }

  // if(typeof def != '')
  if (paths.length == 5) {
    try {
      let val = obj[paths[0]][paths[1]][paths[2]][paths[3]][paths[4]];
      return val !== null ? val : def;
    } catch (e) {
      return def;
    }
  } else if (paths.length == 4) {
    try {
      let val = obj[paths[0]][paths[1]][paths[2]][paths[3]];
      return val !== null ? val : def;
    } catch (e) {
      return def;
    }
  } else if (paths.length == 3) {
    try {
      let val = obj[paths[0]][paths[1]][paths[2]];
      return val !== null ? val : def;
    } catch (e) {
      return def;
    }
  } else if (paths.length == 2) {
    try {
      let val = obj[paths[0]][paths[1]];
      return val !== null ? val : def;
    } catch (e) {
      return def;
    }
  } else if (paths.length == 1) {
    try {
      let val = obj[paths[0]];
      return val !== null ? val : def;
    } catch (e) {
      return def;
    }
  }
  return def;

  /**
  return path.split('.').reduce(function(prev, curr) {
    return prev ? prev[curr] : null
  }, obj || self);
  **/
}

export function highestModel(data, annotations, dateTime = false) {
  data.forEach(series => {
    series.data.forEach(item => {
      if (series.maximum == item.y) {
        let annotation = {
          x: dateTime == true ? new Date(item.x).getTime() : item.x,
          y: item.y,
          marker: {
            size: 8,
            fillColor: '#fff',
            strokeColor: 'red',
            radius: 2,
            cssClass: 'apexcharts-custom-class'
          },
          label: {
            borderColor: '#FF4560',
            offsetY: 0,
            style: {
              color: '#fff',
              background: '#FF4560',
            },

            text: 'Highest Value',
          }
        };
        annotations.points.push(annotation);
      }
    })
  });
  return annotations;
}


export function averageModel(data, annotations) {
  data.forEach(series => {
    let annotation = {
      y: series.average,
      borderColor: '#00E396',
      label: {
        borderColor: '#00E396',
        style: {
          color: '#fff',
          background: '#00E396',
        },
        text: 'Average',
      }
    };
    annotations.yaxis.push(annotation);

  });
  return annotations;
}

export function seriesDataItem(row, x, y, dateTransform = false) {
  let result = {
    x: row[x],
    y: row[y]
  };

  dateTransform = false;
  if (dateTransform == true && row[x]) {
    const m = moment(row[x]);
    // result.dateTimeValue = m.format();
    // result.unixTimeStamp = m.format('X');
    result.month = m.format('MMMM');
    result.dayOfWeek = m.format('dddd');
    result.dayOfWeekNumber = m.format('d');
    result.quarter = m.format('Q');
    result.dayOfMonth = m.format('D');
    result.dayOfYear = m.format('DDD');
    result.weekOfYear = m.format('W');
    result.year = m.format('YYYY');
  }
  return result;
}

export function getChartNode() {

}

export function getDateRange(_startDate, _endDate, dateFormat = 'YYYY MM DD') {
  let dates = [];

  let startDate = moment(_startDate);
  let endDate = moment(_endDate);

  let end = moment(endDate);

  let diff = endDate.diff(startDate, 'days');

  if (!startDate.isValid() || !endDate.isValid() || diff <= 0 || diff >= 800) {
    return dates;
  }

  for (var i = 0; i <= diff; i++) {
    dates.push(end.subtract(i, 'd').format(dateFormat));
  }
  return dates;
};

export function createSQL(subQuery, name = 'name', x = 'x', y = 'y', filters, _transformValue, customFilter = null) {
  let sql = "";
  // x = x == "''" ? 'name' : name;
  x = x ? x : "''";
  name = name ? name : "''";
  x = x == "\"''\"" ? "''" : x;

  if(customFilter && customFilter.trim() == "") {
    customFilter = null;
  }
  if (!name && !x) {
    sql += "SELECT 'name' AS name, 'x' AS x, " + y + " AS y ";
    sql += "FROM (" + subQuery + ") AS subQuery ";
    sql += customFilter ? "WHERE " + customFilter + " " : "WHERE 1 = 1 ";
    if (typeof filters != "undefined") {
      const length = filters.length;
      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];
        sql += " AND " + filter.field + "" + filter.operator + "'" + filter.value + "' ";
      }
    }
    sql += "GROUP BY name, x";
  } else {
    //console.log("item2:" + x + ":");
    sql += "SELECT " + name + " AS name, " + x + " AS x, " + y + " AS y ";
    sql += "FROM (" + subQuery + ") AS subQuery "
    sql += customFilter ? "WHERE " + customFilter + " " : "WHERE 1 = 1 ";
    if (typeof filters != "undefined") {
      const length = filters.length;
      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];
        sql += " AND " + filter.field + "" + filter.operator + "'" + filter.value + "' ";
      }
    }

    let n = name == "''" ? 'name' : name;
    let xx = x == "''" ? 'x' : x;

    sql += "GROUP BY ";
    if(!name || name == "''") {
      sql += xx + " ";
    } else {
      sql += n + "," + xx + " ";
    }
    sql += "ORDER BY " + xx + " ASC";

  }
  //console.log("sql", sql);
  return sql;
}

export function isDateTransformation(transform) {
  // return false;
  if (transform && typeof transform.type != "undefined" && transform.type == "date") {
    return true;
  }
  return false;
}

function isString(value) {
  return typeof value === 'string' || value instanceof String;
}

export function createSeries(data, name = 'name', x = 'x', y = 'y', transform = null) {
  const dateTransform = isDateTransformation(transform);
  // console.log("date transformed", dateTransform);



  /**
    data = data.filter(row => row[name] != null && row[x] != null);
    if (data.length && isString(data[0][x]) && !dateTransform) {
      data = data.sort(function(a, b) {
        const aKey = a[x].trim().toLowerCase();
        const bKey = b[x].trim().toLowerCase();
        if (typeof labels[aKey] != "undefined" && labels[bKey] != "undefined") {
          return labels[aKey].sortKey - labels[bKey].sortKey;
        };
      });
    }**/
  if (!Array.isArray(data)) {
    return [{
      name: 'series 1',
      data: []
    }];
  }
  let results = [];
  let keys = {};
  /**
  let xs = [...new Set(data.map(function(item) {
    return item.x
  }))];**/

  /**
    let xList = xs.map(function(x) {
      return {
        x: x,
        y: null
      };
    });**/
  let xList = [];
  let xs = [];
  let xListCache = {};
  for (let ii = 0; ii < data.length; ii++) {
    if (data[ii][x] == null) {
      continue;
    }
    if (typeof xListCache[data[ii][x]] == "undefined") {
      xListCache[data[ii][x]] = true;
      xs.push(data[ii][x]);
      xList.push({
        x: data[ii][x],
        y: null
      })
    }
  }
  xListCache = null;

  /**
    if(dateTransform == true) {

      xs = [...new Set(data.map(function(item) {
        return moment(item.x);
      }))];
      const minDate = arrMin(xs);
      const maxDate = arrMax(xs);

      let dateRange = getDateRange(moment(minDate).format("YYYY MM DD"), moment(maxDate).format("YYYY MM DD"));
      if(dateRange.length > 0) {
        xs = dateRange;
      }

      //  console.log("dateRange minDate", moment(minDate).format("YYYY MM DD"));
      //  console.log("dateRange maxDate", moment(maxDate).format("YYYY MM DD"));
      //  console.log("dateRange", dateRange);
    }**/


  let i = 0;
  for (let ii = 0; ii < data.length; ii++) {

    let row = data[ii];
    //  data.forEach(function(row) {
    if (typeof row[name] != "undefined" && row[name] != null) {
      if (row[x] == null) {
        continue;
      }
      if (typeof keys[row[name]] == 'undefined') {
        keys[row[name]] = i;
        results[i] = seriesHead(row);
        results[i].label = typeof labels[row[name]] != "undefined" ? labels[row[name]] : {};

        results[i].dataArray = [];
        results[i].sum = 0;
        results[i].average = 0;
        results[i].minimum = 0;
        results[i].maximum = 0;
        results[i].count = 0;
        results[i].data = xList.slice(0);

        
        i++;
      }

      let key = keys[row[name]];
      let result = seriesDataItem(row, x, y, dateTransform);
      let index = xs.indexOf(result[x]);



      if (result.y) {
        results[key].dataArray.push(result.y);
        results[key].minimum = results[key].minimum == 0 ? result.y : results[key].minimum;
        results[key].sum += result.y;
        results[key].minimum = result.y < results[key].minimum ? result.y : results[key].minimum;
        results[key].maximum = result.y > results[key].maximum ? result.y : results[key].minimum;
        results[key].count++;
        results[key].average = results[key].sum / results[key].count;
      }
      results[key].data[index] = result;


    }
    //  });
  }

  //console.log("results change", results);
  for (let ii = 0; ii < results.length; ii++) {
    //  results.forEach(function(row) {
    let row = results[ii];
    row.change = null;
    /**
    const size = row.data.length;
    if (size > 1) {
      const latest = row.data[size - 1].y;
      const previous = row.data[size - 2].y;
      if (latest && previous) {
        row.change = ((latest - previous) / previous) * 100;
      } else if (previous && !latest) {
        row.change = -100;
      } else if (!previous && latest) {
        row.change = 100;
      }
    }**/
    const size = row.dataArray.length;
    if (size > 1) {
      const latest = row.dataArray[size - 1];
      const previous = row.dataArray[size - 2];
      if (latest && previous) {
        row.change = ((latest - previous) / previous) * 100;
      } else if (previous && !latest) {
        row.change = -100;
      } else if (!previous && latest) {
        row.change = 100;
      }
    }


    row.data = row.data.sort(function(a, b) {
    
      if (a.x && b.x) {
 
        const aKey = a.x.trim().toLowerCase();
        const bKey = b.x.trim().toLowerCase();
        if (typeof labels[aKey] != "undefined" && typeof labels[bKey] != "undefined") {
          return labels[aKey].sortKey - labels[bKey].sortKey;
        };
        // return b.sum - a.sum;
      }
    });


    //});
  }

  function getPercentageChange(oldNumber, newNumber){

    return ((latest - previous) / previous) * 100;
}
  // return results;
  // return appendAggregateValues(results).sort(function(a, b) {

  //  console.log("results", results);
  return results.sort(function(a, b) {
    
    if (a.name && b.name) {
      a.name = a.name.trim();
      b.name = b.name.trim();
      const aKey = a.name.trim().toLowerCase();
      const bKey = b.name.trim().toLowerCase();
      if (typeof labels[aKey] != "undefined" && typeof labels[bKey] != "undefined") {
        return labels[aKey].sortKey - labels[bKey].sortKey;
      };
      return b.sum - a.sum;
    }
  });
}


export function nFormatter(num, digits) {
  var si = [{
      value: 1,
      symbol: ""
    },
    {
      value: 1E3,
      symbol: "k"
    },
    {
      value: 1E6,
      symbol: "M"
    },
    {
      value: 1E9,
      symbol: "G"
    },
    {
      value: 1E12,
      symbol: "T"
    },
    {
      value: 1E15,
      symbol: "P"
    },
    {
      value: 1E18,
      symbol: "E"
    }
  ];
  var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }
  return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
}
